// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsGoalsEditTemplate_heading__ewq39","buttonLink":"ReportingDetailsGoalsEditTemplate_buttonLink__Xakxh"};